import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function ErrorDisplay({ stringError, graphQLError }) {
    let displayContents = null;
    if (graphQLError) {
        try {
            if (graphQLError.graphQLErrors.length > 0) {
                const errorMessages = graphQLError.graphQLErrors.map((error, i) => (
                // eslint-disable-next-line react/no-array-index-key
                _jsx("li", { children: error.message }, i)));
                displayContents = _jsx("ul", Object.assign({ className: "list-unstyled m-0" }, { children: errorMessages }));
            }
            else {
                displayContents = _jsx("pre", { children: graphQLError.message });
            }
        }
        catch (formattingError) {
            if (graphQLError.message) {
                displayContents = _jsx("pre", { children: graphQLError.message });
            }
            else {
                displayContents = JSON.stringify(graphQLError);
            }
        }
    }
    else if (stringError) {
        displayContents = stringError;
    }
    else {
        return _jsx(_Fragment, {});
    }
    return _jsx("div", Object.assign({ className: "alert alert-danger" }, { children: displayContents }));
}
export default ErrorDisplay;
//# sourceMappingURL=ErrorDisplay.js.map